import React from 'react'
import SyncButton from '../../ui/sync-button'
import {regHolderBasePath} from '../../reg-holder'

const EnrolmentsSyncButtons = ({regHolder, onComplete}) => (
  <SyncButton
    steps={[
      {
        syncPath: regHolderBasePath(regHolder) + '/sync-gov-enrolments',
        text: 'Pulling records from government',
      },{
        syncPath: regHolderBasePath(regHolder) + '/sync-care-children'
      }
    ]}
    onComplete={onComplete}
  />
)

export default EnrolmentsSyncButtons



// WEBPACK FOOTER //
// ./src/care-enrolments/views/sync-buttons.jsx